import { ListboxButton } from "@headlessui/react";
import { FC, Fragment } from "react";
import { ImgAvatarRounded } from "../atoms/ImgAvatarRounded";
import { SpanIconAnglesAvatar } from "../atoms/SpanIconAnglesAvatar";

type Select = {
  id: number;
  name: string;
  avatar: string;
};

export type ButtonMultiSelectAvatarProps = {
  selected: Select[];
  maxVisible?: number; // Optional prop to limit the number of visible items
};

export const ButtonMultiSelectAvatar: FC<ButtonMultiSelectAvatarProps> = ({
  selected,
  maxVisible = 3, // Default to showing 3 items
}) => {
  const visibleItems = selected.slice(0, maxVisible);
  const hiddenItemCount = selected.length - visibleItems.length;

  return (
    <Fragment>
      <ListboxButton className="relative w-full cursor-default rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-primary-500 sm:text-sm sm:leading-6">
        <span className="flex   items-center flex-wrap">
          {visibleItems.length === 0 ? (
            <span className="flex items-center ">
              <ImgAvatarRounded src="" />
              <span className="ml-3 block truncate">Seleccionar</span>
            </span>
          ) : (
            visibleItems.map((item) => (
              <span key={item.id} className="flex items-center mr-2 ">
                <ImgAvatarRounded src={item.avatar} />
                <span className="ml-3 block truncate">{item.name}</span>
              </span>
            ))
          )}
          {hiddenItemCount > 0 && (
            <span className="flex items-center mr-2 ">
              <span className="ml-3 block truncate">
                +{hiddenItemCount} more
              </span>
            </span>
          )}
        </span>
        <SpanIconAnglesAvatar />
      </ListboxButton>
    </Fragment>
  );
};
